<div *ngIf="student" class="d-flex flex-row justify-content-between align-items-start h-100 w-100 p-3 card mb-2">

    <div>
        <div class="fw-bold fs-5 mb-1">{{ student.name }} {{ student.surname }}</div>
        <div class="text-muted mb-0">DNI: {{ getDNI() }}</div>
        <div class="text-muted mb-0">Edad: {{ getCurrentAge() }}</div>
        <div class="text-muted mb-0">Colegio: {{ student.school }}</div>
    </div>

    <div class="d-flex ">

        <button pButton class="btn button-primary-color mb-2 me-1" title="Ver detalle"
            (click)="goToDetail(student.studentId)">
            <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
        </button>

        <button pButton *ngIf="student.enabled" class="btn button-accent-color mb-2 me-1" title="Editar"
            (click)="goToEdition(student.studentId)">
            <fa-icon [icon]="['fas', 'pen']"></fa-icon>
        </button>

        <button pButton *ngIf="student.enabled" class="btn button-danger-color mb-2" title="Eliminar"
            (click)="disable()">
            <fa-icon [icon]="['fas', 'trash']"></fa-icon>
        </button>

        <button pButton *ngIf="!student.enabled" class="btn button-accent-color mb-2" title="Reactivar"
            (click)="enable()">
            <fa-icon [icon]="['fas', 'check-circle']"></fa-icon>
        </button>

    </div>

</div>